export default {
    map: `
float map( float v, float in_min, float in_max, float out_min, float out_max ) {
    float norm = 0.0;
    if ( in_min < in_max ) {
        norm = min(in_max,max(in_min,v)) - in_min;
        norm /= (in_max-in_min);
    } else if ( in_min > in_max ) {
        norm = min(in_min,max(in_max,v)) - in_max;
        norm /= (in_min-in_max);
        norm = 1.0-norm;
    }

    float result = norm * (out_max-out_min) + out_min;
    float mmin = out_min;
    float mmax = out_max;
    if ( out_min > out_max ) {
        mmin = out_max;
        mmax = out_min;
        result = (1.-norm) * (out_min-out_max) + out_max;
    }
    return min(mmax,max(mmin,result));
}
    `,
    rand: `
float rand(vec2 co) {
    return fract(sin(dot(co, vec2(12.9898, 78.233))) * 43758.5453);
}

float rand(vec3 co) {
    return rand(co.xy + co.z);
}

float rand(float co) {
    return rand(vec2(co, 0.0));
}

float rand(float x, float y) {
    return rand(vec2(x, y));
}

float rand(vec2 c, float minVal, float maxVal) {
    return minVal + (maxVal - minVal) * rand(c);
}

float rand(float c, float minVal, float maxVal) {
    return rand(vec2(c, 0.0), minVal, maxVal);
}
`,
    tuv: `
vec2 tuv(float index, vec2 size) {
    float column = mod(index, size.x);
    float row    = floor(index / size.y);
    return vec2(
        column / (size.y - 1.),
        row / (size.y - 1.)
    );
}
vec2 tuv(float index, ivec2 size) {
    return tuv(index, vec2(size));
}
vec2 vuv(float index, float count){
    float h = floor(sqrt(count));
    float w = floor(count / h);
    
    return tuv(index, vec2(w, h));
}
    `,
    grid_utils: `
struct grid {
    vec2 size;
    vec2 center;
    vec2 origin;
    vec2 coord;
};

vec2 grid_size(uint count){
    float s = sqrt(float(count));
    int closestDivisor = 1;
    for(int i = int(s); i > 1; i--){
        if(int(count) % i == 0){
            closestDivisor = i;
            break;
        }
    }
    return vec2(float(count) / float(closestDivisor), float(closestDivisor));
}

grid grid_info(uint index, vec2 _grid_size, vec2 spacing) {  
    grid info;

    info.coord = vec2(mod(float(index), _grid_size.x), floor(float(index) / _grid_size.x));
    vec2 totalSpacedSize = (_grid_size - 1.0) * spacing + 1.0;
    info.center = totalSpacedSize / 2.0;
    info.size = 1.0 / totalSpacedSize;
    info.origin = (info.coord * spacing) * info.size;
    
    return info; 
}

grid grid_info(uint index, vec2 _grid_size) {  
    return grid_info(index, _grid_size, vec2(.0));
}

grid grid_info(uint index, vec2 g, float spacing) {
    return grid_info(index, g, vec2(spacing));
}

grid grid_info(uint index, uint count, vec2 spacing) {
    return grid_info(index, grid_size(count), spacing); 
}

grid grid_info(uint index, float count, vec2 spacing) {
    return grid_info(index, uint(count), spacing); 
}

grid grid_info(uint index, float count, float spacing) {
    return grid_info(index, uint(count), vec2(spacing)); 
}

grid grid_info(uint index, uint count, float spacing) {
    return grid_info(index, count, vec2(spacing));
}
    `,
};
